module.exports = __webpack_public_path__ + "static/media/pattern_background.c12076b2.png";